import { getDrupalMenu } from '@lucid/utils-drupal';
import { graphql, useStaticQuery } from 'gatsby';
import { type I18n } from 'types/types';

export const useMenuFooter = (languageKey: I18n.AvailableLanguagesKey) =>
  getDrupalMenu(
    useStaticQuery(graphql`
      {
        drupal {
          menuLinkContentQuery(
            limit: 10000
            sort: [{ field: "parent", direction: ASC }, { field: "weight", direction: ASC }]
            filter: { conditions: [{ field: "bundle", value: "footer", operator: EQUAL }] }
          ) {
            entities {
              ...useMenuHook
            }
          }
        }
      }
    `),
    languageKey,
  );

export const query = graphql`
  fragment useMenuFooter on Drupal_MenuLinkContentFooter {
    isEnabled: enabled
    fieldKey
    fieldLinkOverride
    fieldBeaconElementDetail
    fieldDisableLanguage
    fieldProductLink
    fieldIsExternalSourceLink
    fieldIsExternalSourceLinkTi
  }
`;
